// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_m0-0";